var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecvronUpOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.359375C7.26042 0.359375 7.4974 0.463542 7.71094 0.671875L13.6563 6.75781C13.7448 6.84115 13.8125 6.9349 13.8594 7.03906C13.901 7.14844 13.9219 7.26562 13.9219 7.39062C13.9219 7.5625 13.8828 7.71875 13.8047 7.85938C13.7214 8 13.612 8.10938 13.4766 8.1875C13.3411 8.27083 13.1875 8.3125 13.0156 8.3125C12.7656 8.3125 12.5469 8.21875 12.3594 8.03125L6.61719 2.14844H7.375L1.64062 8.03125C1.45312 8.21875 1.23438 8.3125 0.984375 8.3125C0.8125 8.3125 0.658854 8.27083 0.523438 8.1875C0.388021 8.10937 0.28125 8 0.203125 7.85937C0.119792 7.71875 0.078125 7.5625 0.078125 7.39062C0.078125 7.14583 0.166667 6.9349 0.34375 6.75781L6.28906 0.671875C6.38802 0.567708 6.4974 0.489583 6.61719 0.4375C6.73698 0.385417 6.86458 0.359375 7 0.359375Z",
    fill: "#FF8800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecvronUpOrange);
export default __webpack_public_path__ + "static/media/checvronUpOrange.86da32e7553ce58012e861df106f852c.svg";
export { ForwardRef as ReactComponent };